export default "__VITE_ASSET__07d9a04a__"